<script lang="ts" setup>
const props = defineProps<{
  productId: string
}>()

const { t } = useI18n()
const prizeMoney = usePrizeMoney()
const { soldCount, currentlyViewingCount } = useProductMetrics(props.productId)

const addTextContext = (text: string) => text.replace(/(\*\*)(.*?)(\*\*)/g, '<span>$2</span>')
</script>

<template>
  <section>
    <div class="mb-4 flex flex-col gap-y-1">
      <div class="flex content-center items-start items-center">
        <Icon name="lucide:eye" class="flex-shrink-0 text-lg text-orange5" />
        <p
          class="ml2 text-xs text-muted-foreground sm:text-sm [&_span]:text-orange5 [&_span]:fw600"
          v-html="addTextContext(t('product.currently_viewing_n_customers', [currentlyViewingCount]))"
        />
      </div>

      <div class="flex items-start items-center">
        <Icon name="lucide:trophy" class="flex-shrink-0 text-lg text-orange5" />
        <p
          class="ml2 mt-0.5 text-xs text-muted-foreground sm:text-sm [&_span]:text-orange5 [&_span]:fw600"
          v-html="addTextContext(t('promotion.purchase_competition_prizes', [`**${prizeMoney}**`]))"
        />
      </div>

      <div class="flex items-start items-center">
        <Icon class="flex-shrink-0 text-lg text-red4" name="lucide:flame" />
        <p
          class="ml2 mt0.5 text-xs text-muted-foreground sm:text-sm [&>span]:text-red4 [&>span]:fw600"
          v-html="addTextContext(t('product.hot_item_sold_count', [soldCount]))"
        />
      </div>
    </div>
  </section>
</template>
